import React from 'react';
import GalleryCard from './GalleryCard';
import './GalleryGrid.css';

const GalleryGrid = ({ galleries, onDelete, onEdit, onViewPhotos, loading }) => {
  if (loading) {
    return <div className="grid-loading">Loading galleries...</div>;
  }

  if (!galleries || galleries.length === 0) {
    return (
      <div className="no-galleries">
        <p>No galleries found</p>
      </div>
    );
  }

  return (
    <div className="gallery-grid">
      {galleries.map((gallery) => (
        <GalleryCard
          key={gallery.gallery_category_id}
          gallery={gallery}
          onDelete={onDelete}
          onEdit={onEdit}
          onViewPhotos={onViewPhotos}
        />
      ))}
    </div>
  );
};

export default GalleryGrid;
